// todo: delete after all implemented
/**
 * Placeholder for menu entries whose feature does not exist yet.
 *
 * The entries stay in the menu so its final shape is already visible; when a feature lands, replace
 * the call with the real work — done inside the config service itself, or dispatched as an existing
 * coordinator action when the coordinator has to know about it.
 */
export function ldContextMenuTodo(feature: string, payload?: unknown): void {
  console.log(`[LdContextMenu]: "${feature}" is not implemented yet`, payload);
}
